module.exports = '4.15.1';



// WEBPACK FOOTER //
// ./src/version.js